export default __webpack_public_path__ + "static/media/popAd1.f245393b.gif";